import { fromJS } from 'immutable';

import { fetchStaticRoutine } from '../routines';

const initialState = fromJS({
  permissions: {},
  permission: {},
  industries: {},
  loading: false,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case fetchStaticRoutine.SUCCESS:
      return state.set(action.payload.request.type, fromJS(action.payload.response)).set('loading', false);
    case fetchStaticRoutine.FAILURE:
      return state.set('error', action.error).set('loading', false);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/static.js